export default function MoveIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M9.28642 5.52121V2.66406L14.0005 7.37806L9.28642 12.0921V8.87086M9.28642 5.52678C8.85762 5.42948 8.41135 5.3781 7.95309 5.3781C4.63942 5.3781 1.95312 8.06439 1.95312 11.3781C1.95312 11.9564 2.03494 12.5156 2.18764 13.0447C2.90987 10.5419 5.21773 8.7114 7.95309 8.7114C8.41135 8.7114 8.85762 8.7628 9.28642 8.86006"
                stroke="#1A738D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
